import { respondTo } from "@/respondTo";
import Styled from "styled-components";
import { Box, styled as MUIStyled, TextareaAutosize } from "@mui/material";

export const MainContainer = MUIStyled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  gap: "1.25rem",
  padding: "2.5rem 1rem",

  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "2rem 1.5rem",
  },

  [theme.breakpoints.up("lg")]: {
    padding: "3rem 2rem",
  },
}));

export const TitleBox = MUIStyled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",

  [theme.breakpoints.up("sm")]: {
    alignItems: "flex-start",
    justifyContent: "flex-start",
    height: "100%",
  },

  [theme.breakpoints.up("md")]: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    textAlign: "left",
    height: "100%",
    gap: "1.25rem",
  },

  [theme.breakpoints.up("lg")]: {
    gap: "1.25rem",
  },
}));

export const InfoContainer = MUIStyled(Box)(({ theme }) => ({
  display: "none",

  [theme.breakpoints.up("sm")]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    textAlign: "left",
    gap: "1.25rem",
    padding: "2.375rem 0 0 0",
    width: "100%",
  },
}));

export const InnerContainer = MUIStyled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  width: "100%",
  gap: "1rem",

  [theme.breakpoints.up("lg")]: {
    gap: "2rem",
    alignItems: "flex-start",
  },
}));

export const FormContainer = MUIStyled("form")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  gap: "0.5rem",

  [theme.breakpoints.up("md")]: {
    gap: "1rem",
  },
}));

export const FormBox = MUIStyled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  gap: "1.25rem",

  [theme.breakpoints.up("sm")]: {
    flexWrap: "wrap",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    rowGap: "1rem",
    height: "100%",
    width: "100%",
  },

  [theme.breakpoints.up("lg")]: {
    columnGap: "1.25rem",
    padding: "0 0 0.625rem",
  },
}));

export const CheckBox = MUIStyled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
  width: "100%",
  gap: "0.5rem",
  textAlign: "left",
  color: theme.palette.common.corporateColors.primary.white,
}));

export const sxBtn = {
  width: "100%",
  display: "flex",

  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "1.25rem",
  "@media (min-width: 1024px)": {
    flexDirection: "row",
    justifyContent: "flex-start",
  },
};

export const FooterContainer = MUIStyled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  width: "100%",
  gap: "1.25rem",
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));

export const CellectInfoContainer = MUIStyled(Box)`
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    column-gap: 0.5rem;
    `;
